import { apiClient } from "./apiClient";
import { API_ENDPOINTS } from "../../src/constants";
import { ApiResponse, PaginatedResponse, User } from '../types';

export interface ListUsersParams {
  page?: number;
  limit?: number;
  search?: string;
  isKnowledgeBaseEntry?:boolean
}

export const clientService = {
  async getChatbotById(id: string) {
    const result = await apiClient.get(
      API_ENDPOINTS.CLIENT.GET_BY_ID(encodeURIComponent(id)),
      { authenticate: true }
    );
    return (result as any).data ?? (result as unknown);
  },
  
 async list(params: ListUsersParams = {}): Promise<PaginatedResponse<User>> {
  const query = new URLSearchParams();

  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.search) query.set('search', params.search);

  if (params.isKnowledgeBaseEntry !== undefined) {
    query.set('isKnowledgeBaseEntry', String(params.isKnowledgeBaseEntry));
  }

  return apiClient.get<PaginatedResponse<User>>(
    `${API_ENDPOINTS.CLIENT.LIST}?${query.toString()}`,
    { authenticate: true }
  );
}

}



